module.exports = __webpack_public_path__ + "media/images/japan/location_1-627a86fd8dae51897bdeb05ee4bb82d8.png";